import React from "react";


interface NavigationProps {

}


export const Navigation = (props: NavigationProps) => {
  // NOTE: NAVIGATINO BAR IS 81 PX
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/"  style={{ display: "flex", alignItems: "center" }}>
            <img
              src={'/img/motion-logo-white.png'}  // Replace with the correct image path
              alt="Logo"
              style={{ width: "40", height: "40", marginRight: "10px" }} // Adjust size and spacing
            />
            motion
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="/about" className="page-scroll">
                {/*TODO: get rid of the page scroll class, make it only change on hover */}
                About
              </a>
            </li>
            <li>
              <a href="/projects" className="page-scroll">
                Projects
              </a>
            </li>
            <li>
              <a href="/apply" className="page-scroll">
                Apply
              </a>
            </li>
            {/*<li>
              <a href="/#contact" className="page-scroll">
                Contact
              </a>
            </li>*/}
          </ul>
        </div>
      </div>
    </nav>
  );
};
